module.exports = __webpack_public_path__ + "static/media/themain.9983a57f.jpeg";